import { useEffect, useRef, useState, useCallback } from "react";
import CustomDropdown from "./CustomDropdown";
import html2canvas from "html2canvas";
import closeIcon from "./../../images/new/meme/close.svg";
import undoIcon from "./../../images/new/meme/undo.svg";
import redoIcon from "./../../images/new/meme/redo.svg";
import resetIcon from "./../../images/new/meme/reset.svg";
import zoomOutIcon from "./../../images/new/meme/zoomOut.svg";
import zoomInIcon from "./../../images/new/meme/zoomIn.svg";
import downloadIcon from "./../../images/new/meme/download.svg";
import LeftAlign from "./../../images/new/meme/alignLeft.svg";
import CenterAlign from "./../../images/new/meme/alignCenter.svg";
import RightAlign from "./../../images/new/meme/alignRight.svg";
import DraggableImage from "./DraggableImage";
import { Stage, Layer } from "react-konva";
import DraggableText from "./DraggableTextBox";
import { Slide } from "react-toastify";
import assetStickers from "./ImportAssets";
import ImageFetch from "./ImageFetch";
import AssetsList from "./AssetsList";
import { ClipLoader } from "react-spinners";
const MemeEditor = ({
  onHide,
  selectedTemplate,
  stickers,
  fontFamilies,
  fontWeights,
  assets,
}) => {
  function generateUniqueKey() {
    let array = new Uint32Array(1);
    window.crypto.getRandomValues(array);
    return array[0].toString(16);
  }
  const [selectedCategory, setSelectedCategory] = useState(
    Object.keys(assetStickers.Male)[0]
  );
  const [selectedStickerPack, setSelectedStickerPack] = useState([]);
  const parentRef = useRef(null);
  const memeDivRef = useRef(null);
  const [parentWidthHeight, setParentWidthHeight] = useState();
  const [text, setText] = useState({});
  const [selectedAssets, setSelectedAssets] = useState({});
  const [download, setDownload] = useState(false);
  const [templateObjectUrl, setTemplateObjectUrl] = useState(null);
  const [latestImageSelected, setLatestImageSelected] = useState(null);
  const [state, setState] = useState([
    {
      text: {
        0: {
          text: "",
          fontFamily: fontFamilies[0],
          fontWeight: fontWeights[0],
          id: 0,
          fill: "#FFFFFF",
          align: "left",
          stroke: "black",
        },
        1: {
          text: "",
          fontFamily: fontFamilies[0],
          fontWeight: fontWeights[0],
          id: 1,
          fill: "#FFFFFF",
          align: "left",
          stroke: "black",
        },
      },
      selectedAssets: {},
    },
  ]);
  const [redo, setRedo] = useState([]);
  const [selectedId, selectShape] = useState(null);
  const [downloadLoader, setDownloadLoader] = useState(false);
  const checkDeselect = (e) => {
    const clickedOnEmpty = e.target === e.target.getStage();
    if (clickedOnEmpty) {
      selectShape(null);
    }
  };
  useEffect(() => {
    loadImage();
  }, []);
  useEffect(() => {
    document.addEventListener("click", function (event) {
      const contentArea = document.getElementById("Meme");
      const contentArea2 = document.getElementById("customize");
      console.log(contentArea);
      if (
        !contentArea.contains(event.target) &&
        !contentArea2.contains(event.target)
      )
        selectShape(null);
    });
  }, [selectedId]);
  const loadImage = async () => {
    try {
      const response = await fetch(selectedTemplate, {
        headers: { "Cache-Control": "no-cache" },
      });
      const blob = await response.blob();
      const dataUrl = URL.createObjectURL(blob);
      const img = new Image();
      img.src = dataUrl;
      setTemplateObjectUrl(dataUrl);
      if (img.complete) {
        setParentWidthHeight({
          parentHeight: img.height > 380 ? 380 : img.height,
          parentWidth:
            img.height > 380 ? (img.width * 380) / img.height : img.width,
        });
      } else {
        img.onload = () => {
          setParentWidthHeight({
            parentHeight: img.height > 380 ? 380 : img.height,
            parentWidth:
              img.height > 380 ? (img.width * 380) / img.height : img.width,
          });
        };
      }
    } catch (error) {
      console.error("Error loading image:", error);
    }
  };
  useEffect(() => {
    if (latestImageSelected) {
      const key = generateUniqueKey();
      const currentState = state[state.length - 1];
      const temp = {
        ...currentState.selectedAssets,
        [key]: { id: key, url: latestImageSelected, width: 100, height: 100 },
      };
      setState([
        ...state,
        { selectedAssets: { ...temp }, text: { ...currentState.text } },
      ]);
      setRedo([]);
      setLatestImageSelected(null);
    }
  }, [latestImageSelected]);
  useEffect(() => {
    if (download && selectedId) selectShape(null);
    else if (download) handleDownload();
  }, [download]);
  useEffect(() => {
    if (!selectedId && download)
      setTimeout(() => {
        handleDownload();
      }, 100);
  }, [selectedId]);
  useEffect(() => {
    const handleDeleteKeyPress = (event) => {
      console.log(event.keyCode);
      // Check if the user is on Windows
      if (navigator.userAgent.indexOf("Win") !== -1) {
        if (
          (event.key === "Delete" || event.keyCode === 46) &&
          selectedId != null
        ) {
          deleteAsset();
        }
      }

      // Check if the user is on Mac
      if (navigator.userAgent.indexOf("Mac") !== -1) {
        if (
          (event.key === "Delete" || event.keyCode === 8) &&
          selectedId != null
        ) {
          console.log(event.key);
          deleteAsset();
        }
      }
    };
    document.addEventListener("keydown", handleDeleteKeyPress);
    return () => {
      document.removeEventListener("keydown", handleDeleteKeyPress);
    };
  }, [selectedId]);
  useEffect(() => {
    if (selectedCategory) {
      const BASE_URL =
        "https://hh-devserver-bucket.s3.us-east-2.amazonaws.com/Assets/Images/Meme-Generator-Assets/";
      setSelectedStickerPack([
        ...assetStickers.Male[selectedCategory].map((val, index) => {
          return {
            image: BASE_URL + "Male/" + selectedCategory + "/" + val,
            id: generateUniqueKey(),
            name: selectedCategory + `${index + 1}`,
          };
        }),
      ]);
    }
  }, [selectedCategory]);
  useEffect(() => {
    const currentState = state[state.length - 1];
    setSelectedAssets({ ...currentState.selectedAssets });
    setText({ ...currentState.text });
  }, [state]);
  const changeText = (id, key, value) => {
    const currentState = state[state.length - 1];
    const temp = {
      ...currentState.text,
      [id]: { ...currentState.text[id], [key]: value },
    };
    setState([
      ...state,
      { text: { ...temp }, selectedAssets: { ...currentState.selectedAssets } },
    ]);
    setRedo([]);
  };
  const handleClose = () => {
    onHide();
  };
  const addAssets = useCallback((asset) => {
    setLatestImageSelected(asset.image);
  }, []);
  const deleteAsset = () => {
    const currentState = state[state.length - 1];
    const temp = { ...currentState.selectedAssets };
    const temp2 = { ...currentState.text };
    delete temp[selectedId];
    if (temp2[selectedId]) {
      temp2[selectedId].text = "";
    }
    setState([...state, { selectedAssets: { ...temp }, text: { ...temp2 } }]);
    selectShape(null);
  };
  const changeAsset = (key, newAsset) => {
    const currentState = state[state.length - 1];
    const temp = { ...currentState.selectedAssets, [key]: { ...newAsset } };
    setState([
      ...state,
      { selectedAssets: { ...temp }, text: { ...currentState.text } },
    ]);
    setRedo([]);
  };
  const changeEntireText = (key, newText) => {
    const currentState = state[state.length - 1];
    const temp = { ...currentState.text, [key]: { ...newText } };
    setState([
      ...state,
      { selectedAssets: currentState.selectedAssets, text: { ...temp } },
    ]);
    setRedo([]);
  };
  const handleDownload = async () => {
    try {
      html2canvas(memeDivRef.current, {
        useCORS: true,
        allowTaint: true,
        imageTimeout: 0,
        onclone: (clonedDoc) => {
          clonedDoc.getElementById("Meme").style.removeProperty("max-height");
        },
      }).then((canvas) => {
        const dataURL = canvas.toDataURL("image/png");
        const link = document.createElement("a");
        link.download = "meme.png";
        link.href = dataURL;
        link.click();
        setDownloadLoader(false);
        setDownload(false);
      });
      setTimeout(() => {
        setDownloadLoader(true);
      }, 5);
    } catch (error) {
      console.error("Error while capturing element as image:", error);
    }
  };
  return (
    <div className="modalOverlay fade">
      <div className="memeEditorPopup">
        <div className={`memeEditorPopupInner ${downloadLoader ? "fade" : ""}`}>
          <div className="editorSection">
            <div className="tabButtons">
              {parentWidthHeight ? (
                Object.keys(assetStickers.Male).map((key, index) => (
                  <button
                    className={`tabButton ${
                      selectedCategory == key ? "highlight" : ""
                    }`}
                    key={index}
                    onClick={() => {
                      setSelectedCategory(key);
                    }}
                  >
                    {key}
                  </button>
                ))
              ) : (
                <></>
              )}
            </div>
            <div className="mainEditor">
              <div className="stickers">
                {parentWidthHeight ? (
                  <AssetsList
                    selectedCategory={selectedCategory}
                    selectedStickerPack={selectedStickerPack}
                    addAssets={addAssets}
                  />
                ) : (
                  <></>
                )}
              </div>
              <div ref={parentRef} className="template">
                {downloadLoader ? <div className="loader"></div> : <></>}
                {parentWidthHeight && templateObjectUrl ? (
                  <div
                    ref={memeDivRef}
                    style={{
                      margin: "0 auto",
                      width: parentWidthHeight.parentWidth,
                      height: parentWidthHeight.parentHeight,
                      maxHeight: "380px",
                      backgroundImage: `url(${templateObjectUrl})`,
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "contain",
                      backgroundPosition: "center",
                    }}
                    id="Meme"
                  >
                    <Stage
                      width={parentWidthHeight.parentWidth || 100}
                      height={parentWidthHeight.parentHeight || 100}
                      onMouseDown={checkDeselect}
                      onTouchStart={checkDeselect}
                    >
                      <Layer>
                        {Object.keys(selectedAssets).map((key) => {
                          return (
                            <DraggableImage
                              key={key}
                              shapeProps={selectedAssets[key]}
                              isSelected={selectedAssets[key].id === selectedId}
                              onSelect={() => {
                                selectShape(selectedAssets[key].id);
                              }}
                              onChange={(newAttrs) => {
                                changeAsset(key, {
                                  ...selectedAssets[key],
                                  ...newAttrs,
                                });
                              }}
                              link={selectedAssets[key].url}
                            />
                          );
                        })}

                        {Object.keys(text).map((key) => {
                          return text[key].text ? (
                            <DraggableText
                              key={key}
                              shapeProps={text[key]}
                              isSelected={text[key].id === selectedId}
                              onSelect={() => {
                                selectShape(text[key].id);
                              }}
                              onChange={(newAttrs) => {
                                changeEntireText(key, {
                                  ...text[key],
                                  ...newAttrs,
                                });
                              }}
                              text={text[key].text}
                            />
                          ) : (
                            <></>
                          );
                        })}
                      </Layer>
                    </Stage>
                  </div>
                ) : (
                  <></>
                )}
                {/* <img src={selectedTemplate} alt="Selected Template" /> */}
              </div>
            </div>
            <div className="editActionsWrapper">
              <div className="editActions">
                <div className="editAction">
                  <button
                    onClick={() => {
                      if (state.length > 1) {
                        setRedo([...redo, state[state.length - 1]]);
                        setState([...state.slice(0, state.length - 1)]);
                      }
                    }}
                    className="editActionButton"
                  >
                    <img src={undoIcon} alt="Undo" />
                    Undo
                  </button>
                  <button
                    className="editActionButton"
                    onClick={() => {
                      if (redo.length > 0) {
                        setState([...state, redo[redo.length - 1]]);
                        setRedo([...redo.slice(0, redo.length - 1)]);
                      }
                    }}
                  >
                    <img src={redoIcon} alt="Redo" />
                    Redo
                  </button>
                </div>
                <div className="editAction">
                  <button
                    onClick={() => {
                      setState([...state, state[0]]);
                    }}
                    className="editActionButton"
                  >
                    <img src={resetIcon} alt="Reset" />
                    Reset to Default
                  </button>
                </div>
                {/* <div className="editAction">
                  <button className="editActionButton">
                    <img src={zoomOutIcon} alt="Zoom Out" />
                  </button>
                  <button className="editActionButton">
                    <img src={zoomInIcon} alt="Zoom In" />
                  </button>
                </div> */}
              </div>
              <div className="downloadAction">
                <button
                  onClick={() => setDownload(true)}
                  className="downloadButton"
                >
                  <img src={downloadIcon} alt="" />
                  Download
                </button>
              </div>
            </div>
          </div>
          <div
            id="customize"
            className="customizeSection"
            style={{ overflowY: "auto", maxHeight: "600px" }}
          >
            <div className="text-end">
              <button onClick={handleClose}>
                <img className="modalCloseIcon" src={closeIcon} alt="Close" />
              </button>
            </div>
            <h3>Customize</h3>
            {Object.keys(text).map((key, index) => (
              <div className="addText">
                <div className="addTextHeader">
                  <h4>{`Text ${index + 1}`}</h4>
                  <button
                    onClick={() => {
                      const currentState = state[state.length - 1];
                      const temp = { ...currentState.text };
                      delete temp[key];
                      setState([
                        ...state,
                        {
                          selectedAssets: { ...currentState.selectedAssets },
                          text: { ...temp },
                        },
                      ]);
                    }}
                    className="removeAddText"
                  >
                    <img src={closeIcon} alt="Close" />
                  </button>
                </div>
                <textarea
                  name={`Text${index + 1}`}
                  id=""
                  rows="3"
                  placeholder="Top Text"
                  value={text[key].text}
                  onChange={(e) => {
                    changeText(key, "text", e.target.value);
                  }}
                ></textarea>
                <div className="customizeActions">
                  <div className="customizeDropdowns">
                    <CustomDropdown
                      options={fontFamilies}
                      value={text[key].fontFamily}
                      setValue={(val) => {
                        changeText(key, "fontFamily", val);
                      }}
                      extraClass={"extraDropdownClass"}
                    />
                  </div>
                  <div className="customizeAlignments">
                    <button
                      onClick={() => {
                        changeText(key, "align", "left");
                      }}
                    >
                      <img src={LeftAlign} alt="Left Align" />
                    </button>
                    <button
                      onClick={() => {
                        changeText(key, "align", "center");
                      }}
                    >
                      <img src={CenterAlign} alt="Center Align" />
                    </button>
                    <button
                      onClick={() => {
                        changeText(key, "align", "right");
                      }}
                    >
                      <img src={RightAlign} alt="Right Align" />
                    </button>
                  </div>
                </div>
                <div className="colorSelect">
                  <span>Select Color:</span>
                  <input
                    type="color"
                    name=""
                    id=""
                    className="colorInput"
                    value={text[key].fill}
                    onChange={(e) => {
                      changeText(key, "fill", e.target.value);
                    }}
                  />
                </div>
              </div>
            ))}
            <button
              className="customButton primaryButton w-100"
              onClick={() => {
                const key = generateUniqueKey();
                changeEntireText(key, {
                  text: "",
                  fontFamily: fontFamilies[0],
                  fontWeight: fontWeights[0],
                  id: key,
                  fill: "#FFFFFF",
                  aligm: "left",
                  stroke: "black",
                });
              }}
            >
              Add Text
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MemeEditor;
